"use strict";

var _ = require("underscore");
var BaseModel = require("../../common/models/base-model");

var debug = require("debug")("models:PageModel");    //https://github.com/visionmedia/debug

/**
 * PageModel
 */
module.exports = BaseModel.extend({

    pv5api: null,

    defaults: {
        documentId: 0,
        documentTitle: null,
        publicationId: 0,
        publicationTitle: null,
        published: null,
        width: 0,
        height: 0,
        tileSize: 512,     // widelook tile size parameter
        divider: 2,        // widelook divider parameter
        label: [],
        number: [],
        links: [],
        nbLevels: 0,
        isDouble: false
    },

    /**
     * @param  {Object} attributes
     * @param  {Object} attributes.id page number
     * @param  {Object} attributes.documentId document id
     * @param  {Object} attributes.publicationId publication id
     * @param  {Object} options
     * @param  {String} options.pv5api
     */
    initialize: function (attributes, options) {
        BaseModel.prototype.initialize.apply(this, arguments);
        debug("initialize");
        _.extend(this, options);
    },

    url: function () {
        var T = this,
            url = T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("documentId") + "/page/" + T.serverId(),
            query_string = [];
        if (T.mtime) {
            query_string.push("mt=" + T.mtime);
        }
        return T.addQueryStringArrayToUrl(url, query_string);
    },

    serverId: function () {
        var T = this,
            id = T.get("id");
        if (T.isDocumentDouble) {
            if (id != 1 && id % 2) {
                id = id - 1; // si le document est produit en double page, il n'y a des données que pour les pages paires
            }
        }
        return id;
    },

    _computeNbLevels: function (imageWidth, imageHeight, divider, tileSize) {
        var nbLevels = 1,
            val = Math.max(imageWidth, imageHeight);

        while (val > tileSize) {
            val = val / divider;
            nbLevels++;
        }

        //console.log("Nb levels: "+nbLevels);
        return nbLevels;
    },

    tileUrl: function (row, column, level) {
        var T = this,
            url = T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("documentId") + "/page/" + T.serverId() + "/tile/" + row + "/" + column + "/" + level,
            query_string = [];
        if (T.token) {
            query_string.push("token=" + T.token);
        }
        if (T.mtime) {
            query_string.push("mt=" + T.mtime);
        }
        return T.addQueryStringArrayToUrl(url, query_string);
    },

    thumbnailUrl: function () {
        var T = this,
            url = T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("documentId") + "/page/" + T.serverId() + "/thumbnail",
            query_string = [];
        if (T.mtime) {
            query_string.push("mt=" + T.mtime);
        }
        return T.addQueryStringArrayToUrl(url, query_string);
    },

    svgUrl: function (sub) {
        var T = this,
            url = T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("documentId") + "/page/" + T.serverId() + "/svg/" + sub,
            query_string = [];
        if (T.token) {
            query_string.push("token=" + T.token);
        }
        if (T.mtime) {
            query_string.push("mt=" + T.mtime);
        }
        return T.addQueryStringArrayToUrl(url, query_string);
    },

    textUrl: function (rectangle) {
        var T = this,
            url = T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("documentId") + "/page/" + T.serverId() + "/text",
            query_string = [];
        if (T.mtime) {
            query_string.push("mt=" + T.mtime);
        }
        if (rectangle) {
            query_string.push("rectangle=" + rectangle.top + "," + rectangle.left + "," + rectangle.bottom + "," + rectangle.right);
        }
        return T.addQueryStringArrayToUrl(url, query_string);
    },

    parse: function (data) {
        data.nbLevels = this._computeNbLevels(data.width, data.height, data.divider || 2, data.tileSize || 512);
        data.isDouble = data.number.length == 2 ? true : false;
        return data;
    }

});